import { Box, Grid } from "@mui/system";
import { Autocomplete, IconButton, TextField, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";

import AnomaliesMissingDataTable from "./AnomaliesMissingDataTable";

const tableHeadings = {
  brand_name: "Brand Name",
  date: "Date",
  click_out: "Click Out",
  ftd: "FTD (%CVR)",
  qftd: "QFTD (%CVR)",
  cpa_income: "CPA Income",
  rs_income: "RS Income",
  total_income: "Total Income",
  total_income_usd: "Total Income $",
  net_rev: "NetRev",
  epc: "EPC",
  roi: "ROI",
  pv: "PV",
};
export const rows = [
  {
    id: 1,
    brand_name: "BetVictor Sport UK",
    date: "01/05/2026",
    click_out: 137,
    ftd: 2674,
    ftd_cvr: 20.1,
    qftd: 304,
    qftd_cvr: 20.7,
    cpa_income: "£7,440",
    rs_income: "£2,060",
    total_income: "£9,500",
    total_income_usd: "$10,020",
    net_rev: "-$17,292",
    epc: "$151",
    roi: "-337%",
    pv: "$1,004",
  },
  {
    id: 2,
    brand_name: "Gentleman Jim Sport UK",
    date: "01/05/2026",
    click_out: 1174,
    ftd: 2674,
    ftd_cvr: 20.1,
    qftd: 304,
    qftd_cvr: 20.7,
    cpa_income: "£7,440",
    rs_income: "£2,060",
    total_income: "£9,500",
    total_income_usd: "$10,020",
    net_rev: "-$17,292",
    epc: "$151",
    roi: "-337%",
    pv: "$1,004",
  },
];

const AnomaliesMissingData = () => {
  const brandName = [
    { label: "Brand 01" },
    { label: "Brand 02" },
    { label: "Brand 03" },
    { label: "Brand 04" },
  ];

  return (
    <>
      <Grid container spacing={2} alignItems="center" px={2} py={1.5}>
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Missing Data in the Last 2 Days
          </Typography>
        </Grid>
        <Grid size={4}>
          <Box display={"flex"} alignItems={"end"} justifyContent={"flex-end"}>
            <Autocomplete
              id="assetOrSiteName"
              disablePortal
              options={brandName}
              getOptionLabel={(option) => option.label}
              size="small"
              sx={{ pt: "8px", width: "275px" }}
              renderInput={(params) => (
                <TextField
                  color="secondary"
                  {...params}
                  required
                  placeholder="Search Brand Name or choose from the list"
                  label="Brand Name"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <SearchIcon
                          sx={{ fontSize: 20, mr: 1, color: "text.secondary" }}
                        />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <IconButton
              aria-label="fingerprint"
              color="secondary"
              sx={{ ml: 2 }}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <AnomaliesMissingDataTable tableHeadings={tableHeadings} rows={rows} />
    </>
  );
};

export default AnomaliesMissingData;
